import { render } from "./AddUsagerPage.vue?vue&type=template&id=1e27d038&ts=true"
import script from "./AddUsagerPage.vue?vue&type=script&lang=ts"
export * from "./AddUsagerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__